import React from 'react';

export default () =>
  <div>
    <h1>Обо мне</h1>
    <p>
      Меня зовут Денис Бородин, я программист и фотограф.
      Живу в Москве. интересуюсь дизайном, хожу на встречи
      и митапы по фронтэнду и дизайну. В свободное время катаюсь
      на велосипеде и коньках, путешествую по городам.
      Так же занимаюсь съемкой <a href="//tour-360.ru/">360 панорам.</a>
    </p>
    <h3>О чем этот сайт</h3>
    <p>
      Это сайт создавался мною для себя, с целью структурировать
      накопленую информацию. Скорее он похож на фотоальбом чем
      на блог в привычном понимании. Здесь я буду делиться
      фотографиями с разных событий и путишествий.
    </p>
    <h3>Контакты</h3>
    <p>
      Со мной можно связаться по почте <a href="mailto:BorodinDK@gmail.com">BorodinDK@gmail.com</a> или
      по телефону <a href="tell">+7&nbsp;985&nbsp;987&nbsp;38&nbsp;00</a>
    </p>
  </div>;



// WEBPACK FOOTER //
// ./src/pages/about.js